module.exports = __webpack_public_path__ + "static/img/compliance-icon.bb3127b.png";